import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

// CC_LOBBY_SAVE_FINISH (2026-06-03), F2: a second tab opening for the
// same user kicks the first. The backend sends Group/TabKicked to the
// old tab's channel; GameGroupHandler dispatches 'tab-kicked-event'.
// This globally-mounted modal listens for it, force-closes the old
// tab's socket, and shows a one-button acknowledge dialog. The user
// must acknowledge (backdrop static, no Esc) — the engagement now lives
// on the new tab.
//
// MICHAEL-OWNS-COPY: placeholder strings only.
const TAB_KICKED_TITLE = 'Moved to a new window';
const TAB_KICKED_BODY =
    'Moved to a new window. This tab is no longer connected.';
const TAB_KICKED_BUTTON = 'Close this window';

export default function TabKickedModal({ app }) {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const handler = () => {
            // Force the dead tab's socket closed immediately on receipt —
            // the existing socket-close path (API.closeSocket ->
            // SocketHandler.closeSocket). Not improvised; mirrors the
            // path App.reconnectButton uses to reach the socket handler.
            if (app && app.state && app.state.authenticator
                    && typeof app.state.authenticator.closeSocket
                        === 'function') {
                app.state.authenticator.closeSocket();
            }
            setShow(true);
        };
        window.addEventListener('tab-kicked-event', handler);
        return () => {
            window.removeEventListener('tab-kicked-event', handler);
        };
    }, [app]);

    const onClose = () => {
        // Defensive: ensure the socket is closed even if the open-time
        // close above was a no-op (authenticator not yet hydrated).
        if (app && app.state && app.state.authenticator
                && typeof app.state.authenticator.closeSocket
                    === 'function') {
            app.state.authenticator.closeSocket();
        }
        setShow(false);
    };

    return (
        <Modal show={show}
               onHide={onClose}
               backdrop="static"
               keyboard={false}
               centered>
            <Modal.Header>
                <Modal.Title>{TAB_KICKED_TITLE}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{TAB_KICKED_BODY}</Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onClose}>
                    {TAB_KICKED_BUTTON}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
